<template>
  <div>
    <v-row v-if="isError">
      <v-col cols="12">
        <v-alert type="error">
          {{ hosting_error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="isError && inactiveService">
      <v-col cols="12" sm="6">
        <service-info />
      </v-col>
      <v-col cols="12" sm="6">
        <hosting-pending :status="hosting.status" />
      </v-col>
    </v-row>
    <v-row v-if="!isError && !inactiveService">
      <v-col cols="12">
        <gg-loading :loading="loading" type="image" height="86">
          <v-tabs flat background-color="transparent">
            <v-tabs-slider color="green" />
            <v-tab
              v-for="item in menu"
              :key="item.route"
              exact
              :to="{ name: item.route }"
            >
              {{ item.title }}
            </v-tab>
          </v-tabs>
        </gg-loading>
      </v-col>
      <v-col cols="12" class="pb-0">
        <gg-card-title subtitle>
          {{ typeof $route.meta.pageSubtitle === 'function' ? $route.meta.pageSubtitle() : $route.meta.pageSubtitle }}
        </gg-card-title>
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-loading :loading="loading" type="image" height="400">
          <router-view :loading="loading"/>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceInfo from 'Components/Services/Hosting/Common/ServiceInfo'
import HostingPending from 'Components/Services/Hosting/Common/HostingPending'

export default {
  name: 'DedicatedService',
  components: {
    ServiceInfo, HostingPending
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    menu: [
      {
        title: 'Domain Info',
        route: 'hosting_dserver_info',
        icon: 'mdi-information'
      },
      {
        title: 'IP Management',
        route: 'hosting_dserver_address',
        icon: 'mdi-map-marker'
      },
      {
        title: 'Reboot',
        route: 'hosting_dserver_reboot',
        icon: 'mdi-restart'
      },
      {
        title: 'Server Graphs',
        route: 'hosting_dserver_graphs',
        icon: 'mdi-chart-areaspline'
      },
      {
        title: 'Password Management',
        route: 'hosting_dserver_password',
        icon: 'mdi-key-variant'
      },
      {
        title: 'Addons',
        route: 'hosting_vserver_addons',
        icon: 'mdi-puzzle'
      },
    ],
  }),
  computed: {
    ...mapGetters(['hosting', 'hostingPopulated', 'hosting_error']),
    isError () {
      return this.hosting_error !== null
    },
    hostingid () {
      return this.$route.params.hostingid
    },
    inactiveService () {
      return this.hosting.status === 'Pending' || this.hosting.status === 'Suspended'
    }
  },
}
</script>
